import { ACCESS_PROFILES } from '@/const'

export function permissionAccess(perfilUser) {
  if(perfilUser.some((el) => el.name.includes('stic'))) return ACCESS_PROFILES['stic']
  else if(perfilUser.some((el) => el.name.includes('divpol.chefia'))) return ACCESS_PROFILES['divpol.chefia']
  else if(perfilUser.some((el) => el.name.includes('divpol.spessoal'))) return ACCESS_PROFILES['divpol.spessoal']
  else if(perfilUser.some((el) => el.name.includes('chefia'))) return ACCESS_PROFILES['chefia']
  else return null
}